export default __webpack_public_path__ + "static/media/github.0765cc93.png";